export default __webpack_public_path__ + "static/media/achyuth.5069ee3a.jpeg";